import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
// import store from './store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'home',
        component: () =>
            import(/* webpackChunkName: "home" */ '../views/home/index.vue')
    },
    {
        path: '/tailor',
        name: 'tailor',
        component: () =>
            import(/* webpackChunkName: "tailor" */ '../views/tailor/index.vue')
    },
    {
        path: '/tailor/form',
        name: 'tailor-form',
        component: () =>
            import(/* webpackChunkName: "tailor" */ '../views/tailor/form.vue')
    },
    {
        path: '/search',
        name: 'search',
        component: () =>
            import(/* webpackChunkName: "tailor" */ '../views/search/index.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () =>
            import(/* webpackChunkName: "about" */ '../views/about/index.vue')
    },
    {
        path: '/about/team',
        name: 'about-team',
        component: () =>
            import(/* webpackChunkName: "about-team" */ '../views/about/team.vue')
    },
    {
        path: '/about/career',
        name: 'about-career',
        component: () =>
            import(/* webpackChunkName: "about-career" */ '../views/about/career.vue')
    },
    {
        path: '/about/charity',
        name: 'about-charity',
        component: () =>
            import(
        /* webpackChunkName: "about-charity" */ '../views/about/charity.vue'
            )
    },
    {
        path: '/about/press',
        name: 'about-press',
        component: () =>
            import(/* webpackChunkName: "about-press" */ '../views/about/press.vue')
    },
    {
        path: '/about/guest-review',
        name: 'about-guest_review',
        component: () =>
            import(
        /* webpackChunkName: "about-guest_review" */ '../views/about/guest_review.vue'
            )
    },
    {
        path: '/country/:slug',
        name: 'country',
        component: () =>
            import(/* webpackChunkName: "country" */ '../views/country/index.vue')
    },
    {
        path: '/product/:slug',
        name: 'product',
        component: () =>
            import(/* webpackChunkName: "product" */ '../views/product/index.vue')
    },
    {
        path: '/inspiration/:slug',
        name: 'inspiration',
        component: () =>
            import(
        /* webpackChunkName: "inspiration" */ '../views/inspiration/index.vue'
            )
    },
    {
        path: '/experience/:slug?',
        name: 'experience',
        component: () =>
            import(
        /* webpackChunkName: "experience" */ '../views/experience/index.vue'
            )
    },
    {
        path: '/lifestyle/:slug?',
        name: 'lifestyle',
        component: () =>
            import(/* webpackChunkName: "lifestyle" */ '../views/lifestyle/index.vue')
    },
    {
        path: '/article/:slug',
        name: 'article',
        component: () =>
            import(/* webpackChunkName: "article" */ '../views/article/index.vue')
    },
    {
        path: '/term',
        name: 'term',
        component: () => import(/* webpackChunkName: "term" */ '../views/term.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: (to, _from, savedPosition) => {
        if (savedPosition) return savedPosition
        if (to.hash) return { selector: to.hash, offset: { x: 0, y: 96 } }
        return { x: 0, y: 0 }
    }
})

// router.beforeEach((to, from, next) => {
//     // Update the Vuex store with the new route
//     store.dispatch('updateRoute', to.path)
  
//     next() // Always call next() to proceed with the navigation
//   })

export default router
